import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {addQuery} from '@yandex-delivery/utils'

import type {PickupPointsRequest, PickupStation, PickupStationsList} from 'src/shared/types'

import {appConfig, i18n} from '../../config'
import {fetch} from '../fetch'

export function fetchPickUpDropOffPoints(body: PickupPointsRequest): Promise<PickupStation[]> {
  return fetch<PickupPointsRequest, PickupStation[], PickupStationsList>({
    url: addQuery(externalApiURL('/platform/pickup-points/list'), {country: appConfig.countryCode}),
    method: 'POST',
    body,
  }).then((response: PickupStationsList) => {
    if (response.points) {
      return response.points
    }

    throw new Error(i18n('ndd.offers.info.error', 'К сожалению, доставка по указанному адресу недоступна'))
  })
}
